import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import { debounceTime, filter, finalize, Subscription, tap } from 'rxjs';
import { StatusService } from '@dash/randy/shared/classes/status.service';

@Directive({
  selector: '[appNgModelChangeDebounced]',
  standalone: false,
})
export class NgModelChangeDebouncedDirective implements OnInit, OnDestroy {
  @Output() ngModelChangeDebounced = new EventEmitter<any>();
  @Input() ngModelChangeDebounceTime = 1500;

  private subscription: Subscription;

  constructor(private ngModel: NgModel, private statusService: StatusService) {}

  ngOnInit(): void {
    let changeId: number | null = null;

    // View edits only: valueChanges also emits on disable and programmatic model updates.
    this.subscription = this.ngModel.update.pipe(
      filter(() => !this.ngModel.control.disabled),
      tap(() => {
        this.statusService.finishChange(changeId);
        changeId = this.statusService.beginChange();
      }),
      debounceTime(this.ngModelChangeDebounceTime),
      finalize(() => this.statusService.finishChange(changeId)),
    ).subscribe(value => {
      try {
        if (!this.ngModel.control.disabled) {
          this.ngModelChangeDebounced.emit(value);
        }
      } finally {
        this.statusService.finishChange(changeId);
        changeId = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
